import { useCallback } from "react"
import { useTranslation as useI18nextTranslation, type UseTranslationOptions } from "react-i18next"
import type { Namespace } from "i18next"
import { changeLocale, type Locale } from "@/i18n"

export function useTranslation<N extends Namespace>(ns?: N, options?: UseTranslationOptions<undefined>) {
  const { t, i18n } = useI18nextTranslation(ns, options)

  const locale = (i18n.resolvedLanguage ?? i18n.language) as Locale
  const setLocale = useCallback((next: Locale) => changeLocale(next), [])

  return { t, i18n, locale, setLocale }
}
